// extracted by mini-css-extract-plugin
export var left = "success-story-list-module--left--cec1d";
export var listElement = "success-story-list-module--listElement--221df";
export var listWrapper = "success-story-list-module--listWrapper--51ef9";
export var logo = "success-story-list-module--logo--c634e";
export var right = "success-story-list-module--right--33122";
export var select = "success-story-list-module--select--5d3f0";
export var subtitle = "success-story-list-module--subtitle--53c50";
export var technology = "success-story-list-module--technology--07234";